<template>
  <div class="wrap-container">
    <a name="top"></a>
    <div class="header">
      <a href="https://www.cdn.cc">
        <img
          :src="defaultSetting.logo_image"
          alt=""
        />
      </a>
    </div>
    <div class="component">
      <div class="check-list">
        <el-select
          v-model="stateValue"
          placeholder="请选择"
          popper-class="drop-down"
          :filterable="true"
          @change="stateChange(stateValue)"
        >
          <el-option
            v-for="item in stateOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-select
          v-model="provinceValue"
          placeholder="请选择省份"
          popper-class="drop-down"
          :filterable="true"
          :disabled="provinceStatus"
          @change="provinceChange(provinceValue)"
        >
          <el-option
            v-for="item in provinceOptions"
            :key="item.id"
            :label="item.name"
            :value="item.name"
          >
          </el-option>
        </el-select>
        <label>
          <el-select
            v-model="cityValue"
            placeholder="请选择城市"
            popper-class="drop-down"
            :disabled="provinceStatus"
            :filterable="true"
            @change="cityChange(cityValue)"
          >
            <el-option
              v-for="item in cityOptions"
              :key="item.name"
              :label="item.name"
              :value="item.name"
            >
            </el-option>
          </el-select>
        </label>

        <label>
          <el-input
            placeholder="请输入门店名称/地址进行搜索"
            suffix-icon="el-icon-search"
            v-model="inputKey"
            class="input-key"
            maxlength="20"
            :disabled="cityValue || stateIndex == 0 ? false : true"
            @change="keyChange"
          >
          </el-input>
        </label>
      </div>
      <!-- ready,地图组件渲染完毕时触发，返回一个百度地图的核心类和地图实例 -->
      <div class="create-map">
        <baidu-map
          id="map"
          class="mapStyle"
          :center="centerPoint"
          :zoom="15"
          :scroll-wheel-zoom="true"
          @ready="handler"
          @click="getPoint"
        >
          <bm-geolocation
            anchor="BMAP_ANCHOR_BOTTOM_RIGHT"
            :showAddressBar="true"
            :autoLocation="true"
          ></bm-geolocation>
          <bm-local-search
            :keyword="keyword"
            :auto-viewport="true"
            :location="location"
            :panel="false"
            @searchcomplete="getList"
          ></bm-local-search>
          <template v-for="(marker, index) in storeList">
            <bm-marker
              :position="{ lng: marker.lng, lat: marker.lat }"
              @click="infoWindowOpen(index, marker)"
            >
              <bm-label
                :content="index + 1 + ''"
                class="bmlabel"
                :labelStyle="{
                  color: 'white',
                  fontSize: '10px',
                  border: 'none',
                  background: 'none',
                }"
              >
              </bm-label>
              <!-- <bm-label
                :content="12313132"
                class="bmLabel"
                :labelStyle="{
                  width:'100px !important',
                  color: 'black',
                  fontSize: '18px',
                  border: 'none',
                  background: 'white !important',
                }"
              >
              </bm-label> -->
              <!-- :offset="{width: 0, height: 2}" -->
              <bm-info-window
                :show="marker.show"
                @close="infoWindowClose(index)"
                @open="infoWindowOpen(index, marker)"
                class="bm-info-window"
              >
                <div class="marker-content">
                  <p class="marker-title line-hidden">
                    {{ marker.name }}
                  </p>

                </div>
                <div class="marker-content">
                  <span
                    class="info-type"
                    v-if="marker.type"
                  >{{
                      marker.type.name
                    }}</span>
                </div>

                <div class="marker-content">
                  <img
                    src="../../assets/image/lxdh@2x.png"
                    alt=""
                  />
                  <p>
                    <!-- 联系电话： -->
                    {{ marker.contact_phone }}
                  </p>
                </div>
                <div class="marker-content">
                  <img
                    src="../../assets/image/yysj@2x.png"
                    alt=""
                  />
                  <p>
                    <!-- 营业时间： -->
                    {{ marker.open_time_text }}
                  </p>
                </div>
                <div class="marker-content">
                  <img
                    src="../../assets/image/mddz@2x.png"
                    alt=""
                  />
                  <p>
                    <!-- 门店地址： -->
                  <p class="address-line">{{ marker.address }}</p>
                  </p>
                </div>
              </bm-info-window>
            </bm-marker>
          </template>
        </baidu-map>
        <div class="list-allbox">
          <div
            class="list-nodata"
            v-if="storeList.length == 0"
          >
            <img
              src="../../assets/image/wushuju.png"
              alt=""
            />
            <p>当前城市暂无西顿专卖店，我们正在紧锣密鼓建设中，敬请期待……</p>
          </div>
          <ul
            style="overflow: auto"
            class="list-box"
            v-else
          >
            <li
              class="info-box"
              v-for="(item, index) in storeList"
              @click="changeActive(index, item)"
              :key="item.id"
              :class="index + 1 == shopActive ? 'info-box-active' : ''"
              :id="'top'+item.id"
            >
              <a :name="'top'+item.id"></a>

              <div class="info-content">
                <!-- <div class="info-top">
                  <div class="info-top-left">
                    <span class="info-num">{{ index + 1 }}</span>
                    <p class="line-hidden">{{ item.name }}</p>
                    <span
                      class="info-type"
                      v-if="item.type"
                    >{{
                      item.type.name
                    }}</span>
                  </div>
                  <p
                    class="info-top-distance"
                    v-if="item.in_china != 0"
                  >
                    {{ nowAddress ? item.distance : "暂无" }}
                  </p>
                </div> -->
                <div class="info-middle">
                  <div class="middle-left">
                    <div class="middle-left-content info-top-left">
                      <span class="info-num">{{ index + 1 }}</span>
                      <p class="line-hidden">{{ item.name }}</p>
                      <div class="info-type-box">
                        <span
                          class="info-type"
                          v-if="item.type"
                        >{{
                      item.type.name
                    }}</span>
                      </div>
                    </div>
                    <div class="middle-left-content">
                      <img
                        src="../../assets/image/lxdh@2x.png"
                        alt=""
                      />
                      <p>
                        <!-- 联系电话： -->
                        {{ item.contact_phone }}
                      </p>
                    </div>
                    <div class="middle-left-content">
                      <img
                        src="../../assets/image/yysj@2x.png"
                        alt=""
                      />
                      <p>
                        <!-- 营业时间： -->
                        {{ item.open_time_text }}
                      </p>
                    </div>
                    <div class="middle-left-content">
                      <img
                        src="../../assets/image/mddz@2x.png"
                        alt=""
                      />
                      <p>
                        <!-- 门店地址： -->
                      <p class="address-line">{{ item.address }}</p>
                      </p>
                    </div>
                    <!-- <p>联系电话：{{ item.contact_phone }}</p>
                    <p>营业时间：{{ item.open_time_text }}</p>
                    <p>门店地址：{{ item.address }}</p> -->
                  </div>
                  <div
                    class="meddle-right"
                    v-if="item.in_china != 0"
                    @click="nowAddress? goBaiduMap(item):''"
                  >
                    <img
                      src="../../assets/image/daohang.png"
                      alt=""
                    />
                    <p class="info-top-distance">
                      {{ nowAddress ? item.distance : "暂无" }}
                    </p>
                  </div>
                </div>
                <div class="line-cut"></div>
                <div
                  class="info-bottom"
                  @click="copyAddress(item.address)"
                >
                  <img
                    src="../../assets/image/fzdz.png"
                    alt=""
                  />
                  <p>复制地址</p>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="callus">
        <div
          class="call-box1"
          @click="openCallUs = true"
        >
          <img
            src="../../assets/image/lianxi.png"
            alt=""
          />
          <p>联系我们</p>
        </div>
        <div class="call-box2">
          <a href="#top">
            <img
              src="../../assets/image/hddb.png"
              alt=""
            />
          </a>
        </div>
      </div>
      <el-dialog
        title=""
        :visible.sync="openCallUs"
        width="740px"
        center
      >
        <div class="call-popul">
          <img
            :src="defaultSetting.contact_us_image"
            alt=""
          />
          <div class="call-popul-content">
            <p>联系我们</p>
            <p>{{ defaultSetting.contact_us_content }}</p>
            <p>
              <img
                src="../../assets/image/lianxi (1).png"
                alt=""
              />
              {{ defaultSetting.contact_us_phone }}
            </p>
          </div>
        </div>
      </el-dialog>
    </div>
    <div class="footer">
      <a href="https://www.cdn.cc">
        <img
          :src="defaultSetting.logo_image"
          alt=""
        />
      </a>
      <p>联系方式</p>
      <p>{{ defaultSetting.contact_us_phone }}</p>
      <p>在线时间：{{ defaultSetting.online_time_text }}</p>
      <p>地址：{{ defaultSetting.address }}</p>
      <p class="bottom-url">
        <a :href="defaultSetting.url">{{ defaultSetting.number }}</a>
        <a :href="defaultSetting.url">
          <img
            src="../../assets/image/110.png"
            alt=""
          />
          {{ defaultSetting.number_second }}
        </a>
      </p>
    </div>
    <!-- <Footer></Footer> -->
  </div>
</template>

<script>
// import Footer from "@/components/Footer.vue";
import Header from "@/components/Header.vue";
import {
  $getArea,
  $getdefaultSetting,
  $postsearchLog,
  $getStoreList,
  $updataStore,
} from "@/api/index.js";
import {
  distance, Geoloation, GetPoint, arrSort,
  searchPoint,
} from "@/utils/index.js";
import { isMobile } from "../../utils/isMobile";
export default {
  name: "Home",
  data() {
    return {
      location: "惠州",
      keyword: "",
      center: { lng: 0, lat: 0 },
      zoom: 3,
      show: false,
      content: "哈哈哈",
      ak: "SVjQqWYIoeoecUdYzGUy64yRYEHa8qV9",
      map: "",
      // 检索列表
      storeList: [],
      // 联系我们弹窗
      openCallUs: false,
      // 联系我们信息
      show: false,
      keyword: "",
      location: "",
      map: "",
      //中心轴坐标
      centerPoint: {
        lng: 114.423558,
        lat: 23.116359,
      },
      // 当前位置
      nowAddress: "",
      // 标注列表
      markerArr: [
        {
          id: 0,
          lng: 114.412599,
          lat: 23.079404,
          show: false,
        },
        {
          id: 1,
          lng: 114.418,
          lat: 23.079404,
          show: false,
        },
        {
          id: 2,
          lng: 114.4,
          lat: 23.09,
          show: false,
        },
      ],
      // 国家列表
      stateOptions: [
        {
          value: "中国",
          label: "中国",
        },
        {
          value: "海外",
          label: "海外",
        },
      ],
      stateValue: "中国",
      // 国内外
      stateIndex: 1,
      // 省份列表
      provinceOptions: [],
      provinceValue: "",
      // 城市列表
      cityOptions: [],
      cityValue: "",
      // 城市id
      cityId: "",
      // 输入搜索内容内容
      inputKey: "",
      // 国家选择状态
      provinceStatus: false,
      // 门店选中
      shopActive: "",
      // 切换前城市
      beforeCity: localStorage.getItem("beforeCity")
        ? localStorage.getItem("beforeCity")
        : "惠州市",
      // t: 1,
      // 需要更新的商户
      updateStoreList: [],
      // 默认配置
      defaultSetting: "",
      // 距离展示
      defaultDistance: false,
      // 省份地址
      changeCity: '',
      changeProvince: ''
    };
  },
  created() {
    this.postsearchLog(3);
  },
  mounted() {
    let type = this.$route.query.type;
    if (isMobile()) {
      this.$router.push({ path: "/mHome", query: { type } });
    } else {
      // this.$router.push("/");
      this.$router.push({ path: "/", query: { type } });
    }
    this.getdefaultSetting();
    this.getArea();
    this.getTrapeze();
    this.detectDeviceType();
  },
  methods: {
    copyAddress(e) {
      let address = e;
      //创建input标签
      var input = document.createElement("input");
      //将input的值设置为需要复制的内容
      input.value = address;
      //添加input标签
      document.body.appendChild(input);
      //选中input标签
      input.select();
      //执行复制
      document.execCommand("copy");
      //成功提示信息

      this.$message({
        message: "复制地址成功",
        center: true,
        type: "success",
        customClass: "copy-address",
      });
      //移除input标签
      document.body.removeChild(input);
    },
    getList(e) {
      // console.log(e);
    },
    //监听打开该项目的系统
    detectDeviceType() {
      const machineType =
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
          ? "Mobile"
          : "Desktop";
      if (machineType === "Mobile") {
        console.log("移动端");
      } else {
        console.log("Pc端");
      }
    },
    // 获取默认配置
    getdefaultSetting() {
      // if (navigator.geolocation) {
      //   console.log("h5 定位中");
      //   navigator.geolocation.getCurrentPosition(function (position) {
      //     console.log(position)
      //     console.log('h5定位成功；');
      //   }, function (error) {
      //     console.log('h5定失败；');
      //   })
      // }
      $getdefaultSetting().then((res) => {
        this.defaultSetting = res.data;
        if (!this.provinceValue || this.provinceValue == this.provinceValue) {
          this.provinceValue = res.data.default_city.province.name;
        }
        if (!this.cityValue || this.cityValue == this.cityValue) {
          this.cityValue = res.data.default_city.city.name;
        }
        if (!this.cityId || this.cityId == this.cityId) {
          this.cityId = res.data.city_id;
        }
        // console.log(res);
        this.centerPoint.lat = res.data.default_city.city.lat;
        this.centerPoint.lng = res.data.default_city.city.lng;
        this.getStoreList();
        this.provinceChange(this.provinceValue);
      });
    },
    // 完成一次组件卸载 / 重新加载的方法，重新渲染
    async handler({ BMap, map }) {
      // 获取当前位置
      let address
      if (!localStorage.getItem('address')) {
        address = await Geoloation();

        console.log(address);

        let str = JSON.stringify(address);
        localStorage.setItem('address', str)
      }
      let obj = localStorage.getItem('address')
      console.log(obj)
      address = JSON.parse(obj)
      this.nowAddress = JSON.parse(obj);
      this.centerPoint.lng = address.point.lng;
      this.centerPoint.lat = address.point.lat;
      this.defaultDistance = true;
      this.getStoreList();
      if (this.storeList.length) {
        this.infoWindowOpen(0, this.storeList[0])
      }
      // var geolocation = new BMap.Geolocation();
      // geolocation.getCurrentPosition(function (r) {
      //   if (this.getStatus() == BMAP_STATUS_SUCCESS) {
      //     map.panTo(r.point);
      //     alert('您的位置：' + r.point.lng + ',' + r.point.lat);
      //     var point = new BMap.Point(r.point.lng, r.point.lat);
      //     var gc = new BMap.Geocoder();
      //     gc.getLocation(point, function (rs) {
      //       var addComp = rs.addressComponents;
      //       //;
      //       alert(addComp.province + "" + addComp.city + "" + addComp.district)
      //     })
      //     // var myGeo = new BMap.Geocoder();
      //     // 将地址解析结果显示在地图上,并调整地图视野
      //     // myGeo.getPoint(" 北京市海淀区上地10街 ", function (point) {
      //     //   if (point) {
      //     //     map.centerAndZoom(point, 16);
      //     //     map.addOverlay(new BMap.Marker(point));
      //     //   }
      //     // }, " 北京市 ");

      //   }
      //   else {
      //     alert('failed' + this.getStatus());
      //   }
      // });
    },
    // 添加点击函数，点击后修改marker的经纬度
    // getPoint() {
    // 点击获取point经纬度
    // const { lng, lat } = e.point;

    // 获取一个随机不重复的字符串做为id
    // let id = new Date().getTime() + parseInt(Math.random() * 10000);

    // 新增一个marker标记
    // this.markerArr.push({
    //   id: id,
    //   lng: lng,
    //   lat: lat,
    // });
    // },
    // 改变国家
    stateChange(e) {
      // console.log(e == '中国')
      if (e != "中国") {
        this.provinceStatus = true;
        this.stateIndex = 0;
        // this.cityOptions = []
        this.inputKey = "";
        this.shopActive = "";
        this.provinceValue = this.cityValue = ''
      } else {
        this.provinceStatus = false;
        this.stateIndex = 1;
        this.shopActive = "";
        this.cityValue = this.changeCity
        this.provinceValue = this.changeProvince
        this.centerPoint.lng = this.defaultSetting.default_city.city.lng;
        this.centerPoint.lat = this.defaultSetting.default_city.city.lat;
      }
      this.getStoreList();
    },
    // 窗体打开
    infoWindowOpen(index, info) {
      // if (info.id) {
      //   let a = document.createElement('a')
      //   a.href = '#top' + info.id
      //   document.body.appendChild(a);
      //   a.click();
      //   // 然后移除
      //   console.log(a)
      //   document.body.removeChild(a);
      // }
      let distory = 'top' + info.id
      let mainRoot = document.getElementById(distory);
      // console.log(mainRoot)
      mainRoot.scrollIntoView({ behavior: "smooth", block: "nearest" });
      this.storeList[index].show = true;
      this.shopActive = index + 1;
      // console.log(info)

      if (this.stateIndex == 1) {
        this.centerPoint.lat = info.lat;
        this.centerPoint.lng = info.lng;
      }
    },
    infoWindowClose(e) {
      // if (e.id) {
      //   e = e.id - 1
      // } else {
      //   e -= 1
      // }
      this.storeList[e].show = false;
      this.shopActive = "";
    },
    // 改变门店选中
    changeActive(index, info) {
      this.shopActive = index;
      this.infoWindowOpen(index, info);
    },
    // 打开导航
    goBaiduMap(e) {
      // let myaddress = "德明合立方";
      let skipAddress = e;
      // console.log(e)
      this.$alert("是否跳转到地图导航", "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        showCancelButton: true,
        callback: (action) => {
          if (action === "confirm") {
            // window.location.href = "http://api.map.baidu.com/geocoder?address=" + skipAddress + "&output=html&src=" + myaddress
            window.open(
              "http://api.map.baidu.com/geocoder?location=" +
              skipAddress.lat +
              "," +
              skipAddress.lng +
              "&output=html&src=webapp.baidu.openAPIdemo" +
              "_blank"
            );
          }
        },
      });
    },
    // 获取地区、
    getArea() {
      let loadingInstance = this.$loading({
        lock: true,
      });
      $getArea().then((res) => {
        this.provinceOptions = [];
        this.provinceOptions = res.data;
        if (!this.cityOptions.lenth) {
          for (let i = 0; i < this.provinceOptions.length; i++) {
            if (this.provinceOptions[i].name == "广东省") {
              this.cityOptions = this.provinceOptions[i].chlidren;
              break;
            }
          }
        }
        this.$nextTick(() => {
          // 以服务的方式调用的 Loading 需要异步关闭
          loadingInstance.close();
        });
      });
    },
    // 省份切换
    provinceChange(e) {
      for (let i = 0; i < this.provinceOptions.length; i++) {
        if (this.provinceOptions[i].name == e) {
          this.cityOptions = [];
          this.cityValue = "";
          this.cityOptions = this.provinceOptions[i].chlidren;
          break;
        }
      }
    },
    // 城市切换
    async cityChange(e) {
      let loadingInstance = this.$loading({
        lock: true,
      });
      this.shopActive = ''
      for (let i = 0; i < this.cityOptions.length; i++) {
        if (this.cityOptions[i].name == e) {
          this.cityId = this.cityOptions[i].id;
          break;
        }
      }
      this.changeCity = this.cityValue
      this.changeProvince = this.provinceValue
      this.postsearchLog(2);
      let res = await searchPoint(e);
      // this.center.lat = res.Yr[0].point.lat;
      // this.center.lng = res.Yr[0].point.lng;
      setTimeout(() => {
        this.centerPoint.lat = res.Yr[0].point.lat
        this.centerPoint.lng = res.Yr[0].point.lng
        this.getStoreList();
        this.$nextTick(() => {
          // 以服务的方式调用的 Loading 需要异步关闭
          loadingInstance.close();
        });
      }, 2000);
      // let res = await GetPoint(e);
      // // console.log(res)
      // if (e == "赣州市") {
      //   res.lng = 114.93;
      //   res.lat = 25.83;
      // }
      // setTimeout(() => {
      //   this.centerPoint.lat = res.lat;
      //   this.centerPoint.lng = res.lng;
      // }, 2000);
    },
    // 搜索内容改变
    keyChange() {
      this.shopActive = "";
      this.postsearchLog(1);
      // console.log(this.centerPoint);
      this.getStoreList();
    },
    // 添加搜索记录
    postsearchLog(use_type) {
      const { inputKey, cityValue, beforeCity } = this;
      let params = {};
      // let params = {
      //   channel: 1,
      //   use_type,
      //   search_content: inputKey,
      //   search_city: cityValue,
      //   after_change: cityValue,
      //   before_change: localStorage.getItem('beforeCity') ? localStorage.getItem('beforeCity') : beforeCity,
      // };
      // console.log('use' + use_type)
      switch (use_type) {
        case 1:
          params = {
            channel: 1,
            use_type,
            search_content: inputKey,
          };
          break;
        case 2:
          params = {
            channel: 1,
            use_type,
            after_change: cityValue,
            before_change: localStorage.getItem("beforeCity")
              ? localStorage.getItem("beforeCity")
              : beforeCity,
          };
          break;
        case 3:
          params = {
            channel: 1,
            use_type,
            search_city: cityValue ? cityValue : "惠州市",
          };
          break;
      }
      $postsearchLog(params).then((res) => {
        // console.log(res)
        localStorage.setItem("beforeCity", this.cityValue);
      });
    },
    // 逆解析
    // async getTrapeze(e) {
    //   let res = await GetPoint(e);
    //   return res;
    // },
    // 获取门店列表
    getStoreList() {
      const loadingInstance = this.$loading({
        lock: true,
        // text: 'Loading',
      });
      const { inputKey, stateIndex, cityId } = this;
      let params = {
        city_id: stateIndex == 0 ? "" : cityId,
        // city_id: '',
        search_key: inputKey,
        in_china: stateIndex,
      };
      $getStoreList(params).then((res) => {
        let computedList = res.data;
        computedList.forEach(async (item) => {
          if (item.has_data == 0) {
            let fun = {};
            let res = await GetPoint(item.address, this.cityValue);
            item.lat = fun.lat = res.lat;
            item.lng = fun.lng = res.lng;
            fun.id = item.id;
            if (item.in_china == 1) {
              this.updateStoreList.push(fun);
            }
          }
          item.show = false;
          // let address = await Geoloation();

          item.distance = distance(
            this.nowAddress.point.lat,
            this.nowAddress.point.lng,
            item.lat,
            item.lng
          );
        });
        this.storeList = [];

        setTimeout(() => {
          computedList = arrSort(computedList);
          this.storeList = computedList;
          // console.log(computedList)
          this.$nextTick(() => {
            // 以服务的方式调用的 Loading 需要异步关闭
            loadingInstance.close();
            let data = this.updateStoreList;
            if (data.length) {
              $updataStore({ data: data }).then(res => {
                this.updateStoreList = []
              })
            }
            if (this.storeList.length) {
              this.infoWindowOpen(0, this.storeList[0])
            }
          });
        }, 1500);
      });
    },
  },
  computed: {
    //计算属性
  },
  components: {
    // Footer,
    Header,
  },
};
</script>
<style lang="scss" scoped>
.wrap-container {
}
.header {
  width: 100%;
  background: #fff;
  height: 80px;
  display: flex;
  align-items: center;
  padding-left: 120px;
  img {
    height: 20px;
    width: 160px;
  }
}
.map {
  width: 100%;
  height: 98vh;
}
::v-deep .anchorBL,
.BMap_cpyCtrl {
  display: none !important;
}
.content {
  font-size: 18px;
  color: blue;
}
.address {
  font-size: 23px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
  height: 60px;
}
.test {
  width: 24px;
  height: 24px;
  background: #e60000;
  border-radius: 50%;
}

* {
  margin: 0;
  padding: 0;
}
.component {
  background: #eee;
  padding-bottom: 20px;
}

.mapStyle {
  width: 858px;
  height: 100%;
}
.anchorBL {
  display: none !important;
}
// 标注数字居中
.mapStyle {
  ::v-deep .BMapLabel {
    display: flex !important;
    align-items: center;
    justify-content: center;
    margin-top: 2px !important;
    width: 18px !important;
    // height: 25px !important;
  }
}
@media (max-width: 1400px) {
  .mapStyle {
    ::v-deep .BMapLabel {
      display: flex !important;
      align-items: center;
      justify-content: center;
      margin-top: 2px !important;

      width: 25px !important;
      // height: 25px !important;
    }
  }
}
.create-map {
  width: 1400px;
  height: 800px;
  display: flex;
  margin: auto;
  /* background: #959595; */
}
.list-allbox {
  background: #fff;
  width: 542px;
  height: 100%;
}
.list-box {
  // border-radius: 16px;
  background: #f1f1f1;
  width: 100%;
  height: 100%;
  padding: 10px 10px 20px;
}
.info-box {
  // display: flex;
  padding-top: 20px;
  background: #fff;
  // box-shadow: 0px 1px 0px 0px #f9f9f9;
  margin-bottom: 10px;
}
.info-box-active {
  background: #f9f9f9;
}
.info-num {
  width: 18px;
  height: 18px;
  background: #e60000;
  border-radius: 50%;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 13px;
  font-size: 12px;
}
.info-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 5px;
}

.info-top p {
  height: 12px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
  line-height: 15px;
}
.info-top-left {
  display: flex;
  align-items: center;
}
.marker-content {
  display: flex;
  // width: 371px;
  // height: 38px;
  margin: 5px 0 9px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #333333;
  img {
    width: 16px;
    height: 16px;
    margin: 0 5px 0 10px;
  }
}

.create-map ::v-deep .BMap_bubble_content {
  height: 125px !important;
}
.info-type {
  // width: 44px;
  height: 100%;
  border-radius: 5px;
  background: #f58612;
  font-size: 12px;
  color: #ffffff;
  padding: 3px 4px;
  margin-right: 2px;
  text-align: center;
  // display: flex;
  // align-items: center;
  // justify-content: center;
}
.info-type-box {
  flex: 1;
  display: flex;
}
.info-top-left .info-type {
  padding: 0 4px;

  // margin-right: 80px;
  // flex: 1;
  overflow: hidden;
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.marker-content .info-type {
  margin-left: 10px;
}
.info-top-left p {
  overflow: hidden;
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  max-width: 285px !important;
  text-align: left;
}
.address-line {
  flex: 1;
}
.info-top-distance {
  margin-top: 5px;
}
.info-top-left p,
.marker-title {
  // max-width: 200px;
  height: 22px;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
  line-height: 20px;
  margin-left: 10px;
}
.middle-left-content {
  display: flex;
  // align-items: center;
  // width: 371px;
  // height: 38px;
  margin-left: 20px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #333333;
  img {
    width: 16px;
    height: 16px;
    margin-right: 14px;
    margin-top: 6px;
  }
}
.line-hidden {
  // max-width: 345px !important;
  height: auto !important;
  line-height: normal !important;
  margin-top: 0;
  overflow: hidden;
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.marker-content:first-child {
  display: flex;
  align-items: center;
}
.line-cut {
  margin-top: 10px;
  border-bottom: 1px solid #eee;
}
.info-middle {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.middle-left {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 24px;
  padding-right: 10px;
  width: 83%;
  border-right: 1px solid #eee;
}
.middle-left p {
  text-align: left;
  margin: 2px 0;
}
.meddle-right {
  flex: 1;
  display: flex;
  align-items: center;
  flex-direction: column;
  cursor: pointer;
}
.meddle-right p {
  // width: 28px;
  // height: 14px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #e60000;
  line-height: 24px;
}
.meddle-right img {
  width: 20px;
  height: 20px;
}
.info-bottom {
  // margin-left: 35px;
  /* width: 440px; */
  height: 40px;
  background: #fff;
  // border-top: 1px solid #eeeeee;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  // margin-top: 10px;
  cursor: pointer;
  img {
    margin-right: 5px;
    width: 16px;
    height: 16px;
  }
}
.callus {
  position: fixed;
  right: 0;
  top: 30%;
}
.call-box1 {
  width: 40px;
  height: 130px;
  background: #e60000;
  opacity: 0.7;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  cursor: pointer;
}
.call-box1 img {
  width: 20px;
  height: 20px;
}
.call-box1 p {
  width: 15px;
  height: 75px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #ffffff;
  line-height: 20px;
}
.call-box2 {
  width: 40px;
  height: 40px;
  background: #000000;
  opacity: 0.3;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 3px;
}
.call-box2 img {
  width: 22px;
  height: 12px;
}
.call-popul {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 10px 30px;
}
.call-popul img {
  width: 257px;
  height: 175px;
}
.call-popul-content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 160px;
}
.call-popul-content p {
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
  margin-left: 20px;
}
.call-popul-content p:nth-child(2) {
  font-size: 16px;
  font-family: PingFang SC;
  color: #666666;
}
.call-popul-content img {
  width: 24px;
  height: 24px;
}
.copy-address {
  width: 154px;
  height: 44px;
  background: #000000;
  opacity: 0.6;
  color: #fff;
}
.check-list {
  width: 1400px;
  margin: auto;
  padding: 20px 0;
  display: flex;
  justify-content: space-between;
}
.input-key {
  width: 542px;
  // height: 48px;
  text-align: left;
  ::v-deep .el-input__inner {
    width: 542px !important;
  }
}
.check-list {
  ::v-deep .el-input--suffix {
    background: #fff;
  }
}
.check-list {
  ::v-deep .el-input__inner {
    border: none;
    height: 48px !important;
    width: 264px;
  }
}
.drop-down .el-scrollbar .el-select-dropdown__item {
  padding: 0 12px !important;
}
.drop-down .el-scrollbar .el-select-dropdown__item.selected {
  color: #606266;
}
.footer {
  img {
    margin: 30px;
    width: 232px;
    height: 30px;
  }
  p {
    margin: 3px auto;
  }
  & p:nth-child(2) {
    // width: 73px;
    // height: 17px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 28px;
  }
  & p:nth-child(3) {
    // width: 178px;
    // height: 19px;
    font-size: 24px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #e60000;
    // line-height: 28px;
  }
  & p:nth-child(4) {
    // height: 14px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: 28px;
  }
  & p:nth-child(5) {
    // width: 449px;
    // height: 14px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: 28px;
  }
  & p:nth-child(6) {
    width: 100%;
    height: 40px !important;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f9f9f9;
    a {
      height: 14px;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #999999;
    }
  }
}
::v-deep .BMap_bubble_content {
  height: 150px !important;
  width: 402px !important;
}

.list-nodata {
  margin-top: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  img {
    width: 176px;
    height: 142px;
  }
  p {
    width: 324px;
    height: 38px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #999999;
    line-height: 24px;
  }
}
.bottom-url {
  a:hover {
    color: red !important;
  }
  img {
    margin-left: 20px !important;
    width: 20px;
    height: 20px;
    margin: 0;
  }
}
::v-deep .BMap_pop > div:nth-child(7) > div,
::v-deep .BMap_pop > div:nth-child(5) > div,
::v-deep .BMap_pop > div:nth-child(3) > div,
::v-deep .BMap_pop > div:nth-child(1) > div {
  border-radius: 4px;
}
</style>
